// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    root: {
        url: "https://productdatabasewebdev.z5.web.core.windows.net"
    },
    azure: {
        url: 'https://productdatabase-dev-svc.azurewebsites.net'
    },
    okta: {
        clientid: '0oazr78xr0m09RZyd0x7',
        issuer: 'https://hccommunity.okta.com/oauth2/default'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
